module.exports = __webpack_public_path__ + "static/media/minus.d400e023.svg";